<template>
  <div>
    <!-- @todo: convert to collapsible -->
    <div v-if="!pendingChanges"></div>
    <div v-else class="box">
      <div class="top" @click="toggleShowContent" >
        <h3 class="title">Pending Changes</h3>
        <span>
          <i class="fa fa-caret-down"></i>
        </span>
      </div>
      <ul v-if="showContent" class="list">
        <li
          v-for="(item, index) in Object.entries(pendingChanges)"
          :key="index"
          class="item"
          v-html="renderItem(item)"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
// import { Switch } from "element-ui";

export default {
  name: "ElementPendingInfo",
  props: {
    pendingChanges: null
  },
  components: {},
  data() {
    return {
      isLoading: false,
      showContent: true
    };
  },
  watch: {
    defaultValue: {}
  },
  methods: {
    showLoading(value) {
      this.isLoading = value;
    },
    renderItem(item) {
      if (item.length > 1) {
        // @todo: should lookup dictionary and do normal
        return `<span>${item[0]}</span>: <span>${item[1]}</span>`;
      }
      return "invalid";
    },
    toggleShowContent(){
      this.showContent = !this.showContent
    }
  },
  async mounted() {
    // this.pendingChanges = await this.getPendingChanges();
  }
};
</script>

<style lang="scss" scoped>
.box {
  color: #e6a23c;
  background: #fdf6ec;
  border-color: #f5dab1;
  padding: 6px 24px;
  border-radius: 6px;
  margin-bottom: 24px;
}

.title {
  line-height: normal;
  font-size: 16px;
}

.list {
  margin: 0;
  padding: 0;
}

.item {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  padding: 5px 0;

  & + .item {
    border-top: 1px solid #f0d7b3;
  }
}

.top{
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/performance/controls/element-pending-info.vue